import type { Fiche } from '@pharmafiche/schema';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

/**
 * In-memory fiche cache.
 *
 * Phase 8 will persist this to IndexedDB via `idb` and key by `fiche.id`.
 * Until then, refreshing the page wipes the cache and the editor route
 * shows "Fiche introuvable".
 */
interface FicheStoreState {
  fiches: Record<string, Fiche>;
  put: (fiche: Fiche) => void;
  get: (id: string) => Fiche | undefined;
  remove: (id: string) => void;
}

export const useFicheStore = create<FicheStoreState>()(
  immer((set, get) => ({
    fiches: {},
    put: (fiche) =>
      set((s) => {
        s.fiches[fiche.id] = fiche;
      }),
    get: (id) => get().fiches[id],
    remove: (id) =>
      set((s) => {
        delete s.fiches[id];
      }),
  })),
);
